import mutationsFunctions from "./mutationsFunctions";

function useCachedMutations(toast) {
  const resumeCachedMutations = (queryClient) => {
    const pausedMutations = queryClient.getMutationCache().getAll();

    if (pausedMutations) {
      pausedMutations.forEach(async (mutation) => {
        const key = mutation.options?.mutationKey;

        const props = mutation.state?.variables;

        const fn = mutationsFunctions[key];

        if (fn && typeof fn == "function") {
          await fn(props).then((data) => {
            successCallback(key, data);
          });
        } else {
          errorCallback({
            message: "Function não encontrada, verifique a parametrização das mutations",
            isSuccess: false,
            status: 400,
          });
        }

        queryClient.getMutationCache().remove(mutation);
      });
    }
  };

  const successCallback = (key, data) => {
    if (data) {
      if (data.status == 400) {
        errorCallback(key, data);
        return;
      }

      toast({
        title: `Função ${key} executada com sucesso`,
        description: data?.message ?? "Sucesso",
        status: "success",
        duration: 9000,
        isClosable: true,
        position: "top-right"
      });
    }
  };

  const errorCallback = (key, erro) => {
    if (erro) {
      console.error("erro: ", erro);

      toast({
        title: `Erro ao executar a função ${key}`,
        description: erro?.message ?? "Houve uma falha inesperada, entre em contato com o suporte",
        status: "error",
        duration: 9000,
        isClosable: true,
        position: "top-right"
      });
    }
  };

  return {
    resumeCachedMutations,
    successCallback,
    errorCallback,
  };
}

export default useCachedMutations;
